import {SystemLanguage} from '@/services/enumTranslator/SystemLanguage';
import {DomainAgreements} from '@/env/Agreements/types';

export const agreementsNesto: DomainAgreements = {
  [SystemLanguage.RO]: {
    AcceptsImobiliarePersonalDataProcessing: {
      title: 'INTERMEDIERE FINANCIARA',
      label: 'Sunt de acord cu procesarea datelor mele personale de catre Imobiliare.ro Finance SRL pentru a efectua serviciul de intermediere financiara si serviciile conexe.',
    },
    AcceptsImobiliareCommercialInformation: {
      title: 'INFORMATII COMERCIALE',
      label: 'Sunt de acord sa primesc comunicari comerciale privind derularea solicitarii mele de credit, adresate mie de Imobiliare.ro Finance SRL in concordanta cu prevederile Regulamentului 2016 / 679.',
    },
    AcceptsImobiliareMarketing: {
      title: 'MARKETING',
      label: 'Sunt de acord sa primesc comunicari de marketing adresate mie de Imobiliare.ro Finance SRL prin e-mail si/ sau SMS, in concordanta cu prevederile Regulamentului 2016 / 679.',
    },
    AcceptsHomeEstatePersonalDataProcessing: {
      title: 'INFORMATII IMOBILIARE',
      label: 'Sunt de acord sa primesc comunicari privind ofertele imobiliare adresate mie de Imobiliare.ro Finance SRL prin e-mail si/ sau SMS, in concordanta cu prevederile Regulamentului 2016 / 679.',
    },
  },
};
